import { Link } from 'react-router-dom';
import type { Work } from '@/types/media';

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-300 transition-colors duration-300"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 封面`}
          title={`${work.title} - 夏目彩春影视作品`}
          className="w-full h-full object-top object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-label tracking-wide">
          {work.type}
        </span>
        <span className="absolute top-3 right-3 px-2 py-1 rounded-md bg-foreground-950/60 backdrop-blur-sm text-background-50 text-xs font-label">
          {work.year}
        </span>
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-heading font-bold text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {work.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500">{work.genre}</p>
        <p className="mt-2.5 text-sm text-foreground-700 leading-relaxed line-clamp-2 flex-1">{work.summary}</p>
        <div className="mt-3.5 flex items-center justify-between">
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-calendar-line" />
            {work.year}
          </span>
          <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
            <i className="ri-star-fill" />
            {work.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}